import actions from 'constants/reducers';
import { useAppContext } from 'hooks/useAppContext';
import { useGlobals } from 'hooks/useGlobals';

const useDrawerCheckout = () => {
  const { dispatch, state } = useAppContext();
  const { user } = useGlobals();

  const { checkoutDrawer } = state || {};

  const { isOpen, isLoading } = checkoutDrawer;

  const viewDrawerCheckout = () => {
    dispatch({ type: actions.checkoutDrawer.set, payload: null });
    return false;
  };

  const closeDrawer = () => {
    dispatch({ type: actions.checkoutDrawer.close, payload: null });
  };

  return {
    isOpen,
    isLoading,
    viewDrawerCheckout,
    closeDrawer,
    isAllowed: user?.data?.permissionId !== 3,
  };
};

export { useDrawerCheckout };
